import { Users, X } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import UserFilterMultiSelect, { type UserFilterOption } from "../UserFilterMultiSelect";
import type { InstanceScope } from "./processScopeModel";

const triggerClassName =
  "inline-flex h-[30px] max-w-60 shrink-0 items-center justify-between gap-2 rounded-full px-3 text-xs font-medium text-text outline-none transition hover:bg-muted-surface focus-visible:ring-2 focus-visible:ring-info/20";

export default function ProcessPeopleFilter({
  scope,
  userOptions,
  onChange,
}: {
  scope: InstanceScope;
  userOptions: UserFilterOption[];
  onChange: (scope: InstanceScope) => void;
}) {
  const { t } = useTranslation();
  const active =
    !!scope.noUsers ||
    (scope.userIds.length > 0 && userOptions.some(option => !scope.userIds.includes(option.id)));
  return (
    <div
      className={`flex min-w-0 max-w-60 items-center [&>div]:min-w-0 rounded-full border border-outline ${active ? "bg-muted-surface" : "bg-surface"}`}
    >
      <UserFilterMultiSelect
        pill
        triggerClassName={`${triggerClassName} ${active ? "font-medium" : ""}`}
        hideChevron={active}
        icon={<Users className="h-4 w-4 shrink-0 text-text-dim" aria-hidden="true" />}
        allLabel={t("watchlist.all_people")}
        value={
          scope.noUsers
            ? []
            : scope.userIds.length
              ? scope.userIds
              : userOptions.map(option => option.id)
        }
        options={userOptions}
        onChange={userIds =>
          onChange({
            ...scope,
            userIds: userIds.length === userOptions.length ? [] : userIds,
            noUsers: userIds.length === 0,
          })
        }
      />
      {active && (
        <button
          type="button"
          aria-label={t("processPage.clearFilter", { filter: t("processPage.people") })}
          onClick={() => onChange({ ...scope, userIds: [], noUsers: false })}
          className="mr-1 shrink-0 rounded-full p-1 text-text-dim hover:bg-surface hover:text-text focus-visible:ring-2 focus-visible:ring-info/20"
        >
          <X className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
